import axios from "axios";
import { resolveApiBaseUrl } from "./urls";

const api = axios.create({
  baseURL: resolveApiBaseUrl(),
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Don't auto-redirect on 401 - let components handle authentication
    // Only log the error for debugging
    if (error.response?.status === 401) {
      console.log("Unauthorized request:", error.config?.url);
    }
    return Promise.reject(error);
  },
);

export default api;
